// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"styles_modal-wrapper__uaRbz","background":"styles_background__62sJX","card":"styles_card__pFR2d","card-medium":"styles_card-medium__q2xPH"};